import script from "./RouterButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterButtons.vue?vue&type=script&setup=true&lang=js"

import "./RouterButtons.vue?vue&type=style&index=0&id=75d6128c&lang=scss&scoped=true"

import exportComponent from "C:\\AQ_Repo\\customermanagedinspection_fe - Brandsäkra Norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d6128c"]])

export default __exports__